import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'

export const IdentityProviderTypes = {
	oidc: 'OpenID Connect',
} as const
export type IdentityProviderType = keyof typeof IdentityProviderTypes
export const IdentityProviderProviderTypes = {
	m365: 'Microsoft 365',
	custom: 'Custom',
}
export type IdentityProviderProviderType =
	keyof typeof IdentityProviderProviderTypes

@jsonClass('IdentityProvider')
export class IdentityProvider {
	@jsonProperty(String)
	get __type(): string {
		return 'IdentityProvider'
	}
	set __type(_) {}

	// TODO: add tenantId evantually
	@jsonProperty(String)
	id: string
	@jsonProperty(String)
	clientId: string
	@jsonProperty(String)
	name: string
	@jsonProperty(Boolean)
	useForSsoLogin: boolean = true
	@jsonProperty(String)
	type: IdentityProviderType = 'oidc'
	@jsonProperty(String)
	providerType?: IdentityProviderProviderType = 'm365'
	@jsonProperty(String)
	clientSecret: string
	@jsonProperty(String)
	idpTenantId: string
	@jsonProperty(String)
	customIssuerUrl: string
	@jsonProperty(String)
	scope: string = 'openid profile email'

	constructor(init?: Partial<IdentityProvider>) {
		assignCommonProperties(this, init)
	}

	get effectivveIssuerUrl() {
		if (this.type == 'oidc') {
			if (this.providerType == 'm365') {
				return `https://login.microsoftonline.com/${this.idpTenantId}/v2.0`
			}
		}
		return this.customIssuerUrl
	}
}
